import {
  HubspotEventEnum,
  hubspotTrackEvent,
} from "@tudigo-monorepo/web-tudigo-tracking";

import { useSessionStore } from "../providers/session/session-store";

export function useHubspotTrackEvent(
  name: HubspotEventEnum,
): undefined | ((properties: Record<string, string | undefined>) => void) {
  const configuration = useSessionStore((state) => state.configuration);

  const eventKey = configuration?.hubspotEvents?.find(
    (event) => event.name === name,
  )?.key;

  if (!eventKey) {
    console.warn(`Event ${name} not found in configuration`);

    return;
  }

  return (properties: Record<string, string | undefined>) =>
    hubspotTrackEvent(eventKey, properties);
}
